<template>
    <div ref="menstruation" class="menstruation-warp" v-show="show">
        <div class="symptom-list-wrapper">
            <div class="symptom-list">
                <div class="list-title">寒热</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in febrileList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
            <div class="symptom-list">
                <div class="list-title">汗出</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in perspirationList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
            <div class="border-line"></div>
            <div class="symptom-list">
                <div class="list-title">眠志</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in sleepList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
            <div class="symptom-list">
                <div class="list-title">饮食</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in dietList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
            <div class="symptom-list">
                <div class="list-title">大便</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in urineList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
            <div class="symptom-list">
                <div class="list-title">小便</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in fecesList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
        </div>
        <div class="close-suggestions" @click="close">
            <i class="el-icon-circle-close mr8 size16"></i>
            关闭
        </div>
    </div>
</template>

<script>
import { isEmptyArray, isArray, isObject, isNull } from '../utils/validateBase'
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        presentCondition: {
            type: String,
            default: ''
        },
    },
    watch:{
      presentCondition: {
        handler(val) {
          this.presentConditionList = isNull(val) ? [] : val.split(',')
        },
        immediate: true
      }
    },
    data() {
        return {
            febrileList: [
                { value: '1', label: '恶风' },
                { value: '2', label: '恶寒' },
                { value: '3', label: '怕冷' },
                { value: '4', label: '发热' },
                { value: '5', label: '潮热' },
                { value: '6', label: '低热' },
                { value: '7', label: '手心热' },
                { value: '8', label: '脚心热' },
                { value: '9', label: '夜间发热' },
                { value: '10', label: '寒热往来' },
            ],
            perspirationList: [
                { value: '1', label: '自汗' },
                { value: '2', label: '盗汗' },
                { value: '3', label: '汗多' },
                { value: '4', label: '汗黏' },
                { value: '5', label: '冷汗' },
                { value: '6', label: '头汗' },
                { value: '7', label: '背汗' },
                { value: '8', label: '手汗' },
                { value: '9', label: '脚汗' },
            ],
            sleepList: [
                { value: '1', label: '眠可' },
                { value: '2', label: '眠差' },
                { value: '3', label: '眠浅' },
                { value: '4', label: '多梦' },
                { value: '5', label: '易醒' },
                { value: '6', label: '早醒' },
                { value: '7', label: '入睡困难' },
                { value: '8', label: '嗜睡' },
                { value: '9', label: '情绪正常' },
                { value: '10', label: '压力大' },
                { value: '11', label: '易怒' },
                { value: '12', label: '易躁' },
                { value: '13', label: '焦虑' },
                { value: '14', label: '抑郁' },
                { value: '15', label: '心烦' },
            ],
            dietList: [
                { value: '1', label: '纳可' },
                { value: '2', label: '纳差' },
                { value: '3', label: '厌食' },
                { value: '4', label: '易饿' },
                { value: '5', label: '饥不欲食' },
                { value: '6', label: '口干' },
                { value: '7', label: '口苦' },
                { value: '8', label: '口淡' },
                { value: '9', label: '口黏' },
                { value: '10', label: '口干欲饮' },
                { value: '11', label: '渴不欲饮' },
                { value: '12', label: '喜冷饮' },
                { value: '13', label: '喜热饮' },
            ],
            fecesList:[
              { value: '1', label: '小便正常' },
              { value: '2', label: '小便黄' },
              { value: '3', label: '小便清长' },
              { value: '4', label: '尿频' },
              { value: '5', label: '尿急' },
              { value: '6', label: '尿痛' },
            ], 
            urineList: [
                { value: '1', label: '大便正常' },
                { value: '2', label: '便溏' },
                { value: '3', label: '大便黏' },
                { value: '4', label: '大便干' },
                { value: '5', label: '完谷不化' },
                { value: '6', label: '溏结不调' },
            ],
            presentConditionList:[]
        }
    },
    methods:{
        //添加每项内容
        addItem(item){
            if(!this.presentConditionList.includes(item)){
                this.presentConditionList.push(item);
                this.$emit('presentConditionChange',this.presentConditionList)
            }
        },
        close(){
            this.$emit('close')
        }

    }
}
</script>
<style lang="less">
.pregnancy-popover {
    min-width: 100px;
    padding: 6px;
    box-sizing: border-box;

    .el-popover__title {
        font-size: 12px;
        margin-bottom: 6px;
        text-align: center;
    }

    .pregnancy-num-warp {
        align-items: center;
        border-radius: 4px;
        color: #474747;
        cursor: pointer;
        display: inline-flex;
        font-size: 12px;
        height: 28px;
        justify-content: center;
        margin: 1px;
        width: 28px;
    }

    .hover-eff3f6 {
        &:hover {
            background-color: #eff3f6;
        }
    }
}
</style>
<style lang="less" scoped>
.hover-c6e2ff {
    &:hover {
        background-color: #c6e2ff;
        color: #0090ff
    }
}

.hover-eff3f6 {
    &:hover {
        background-color: #eff3f6;
    }
}

.menstruation-warp {
    background-color: #fff;
    border: 1px solid #b7b9c2;
    border-radius: 4px;
    font-size: 14px;
    left: 180px;
    min-width: 400px;
    position: absolute;
    width: 650px;
    z-index: 1009;
    bottom: -310px;
    .border-line{
        background-color: #dadbe0;
        font-size: 0;
        height: 1px;
        margin: 0 8px
    }
    
    .symptom-list-wrapper {
        padding: 0 7px;

        .symptom-list {
            display: flex;
            margin: 8px 0;
            padding: 0;

            .list-title {
                font-weight: 700;
                line-height: 1;
                margin: 0;
                min-width: 74px;
                padding: 5px 8px;
            }

            .list-item {
                display: flex;
                margin-bottom: 2px;
                align-items: center;
                flex-wrap: wrap;
                .item-warp {
                    border-radius: 4px;
                    color: #7a8794;
                    cursor: pointer;
                    display: inline-block;
                    line-height: 1;
                    padding: 5px 8px;
                    user-select: none;
                    white-space: nowrap;
                }
                .menstruation-info{
                    display: inline-flex;
                    flex-direction: column;
                    width: 72px;
                    .cut-line{
                        border-bottom-color: #e0e2eb;
                        height: 1px;
                        width: 100%;
                        background-color: #dadbe0;
                        font-size: 0;
                    }
                }
                .el-date-editor{
                    width: 110px;
                    cursor: pointer;
                    /deep/.el-input__inner{
                        font-size: 14px;
                        border-radius: 4px;
                        color: #7a8794;
                        padding: 5px 8px;
                        // padding-right: 0;
                        border-color: transparent;
                        &:hover{
                            background-color: #eff3f6;
                        }
                    }
                }
                /deep/.el-input__prefix{
                    display: none
                }


            }
        }
        
    }
    .close-suggestions{
        align-items: center;
        background: #f7f7f7;
        border-radius: 0 0 4px 4px;
        color: #005ed9;
        cursor: pointer;
        display: flex;
        font-weight: 500;
        height: 40px;
        justify-content: center;
        line-height: 40px;
        position: relative;
        width: 100%;
    }
}
</style>